export const NOT_ONLY_WHITESPACE_PATTERN = /^\S.*$/;
